"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketProvider = exports.SocketContext = void 0;
// TO DO add Flow to this file, importing phoenix via npm run flow-type-install results in a strange error that blocks the build
const react_1 = __importStar(require("react"));
const phoenix_1 = require("phoenix");
exports.SocketContext = react_1.default.createContext(null);
// eslint-disable-next-line react/prop-types
function SocketProvider({ children, options, url }) {
    const [socket, setSocket] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        const newSocket = new phoenix_1.Socket(url, options);
        newSocket.connect();
        setSocket(newSocket);
        return () => {
            newSocket.disconnect();
            setSocket(null);
        };
    }, [options, url]);
    const props = {
        value: {
            socket,
        },
    };
    return react_1.default.createElement(exports.SocketContext.Provider, Object.assign({}, props), children);
}
exports.SocketProvider = SocketProvider;
